import React from "react";
import moment from "moment";
import { HCheckbox } from "../../../validation/HForm";
import {
  AccommodationType,
  calculationCreditHistory, Education, FamilyStatus, JobTenure, JobType, PladgeStatus, requestClientData,
  requestCreditHistory,
  requestsData,
  RequestStatus
} from "../constants/constants";

export const getDisplayValue = (label, value, handleCheckboxChange) => {
  const unitMap = {
    [requestsData.odometer]: "км",
    [requestsData.desiredAmount]: "BYN",
    [requestsData.estimatedValue]: "BYN",
    [requestsData.maxLoanAmount]: "BYN",
    [requestsData.desiredTerm]: "мес",
    [requestsData.status]: (statusValue) =>
      RequestStatus[statusValue]?.label || statusValue,
    [requestsData.pledgeStatus]: (value) => PladgeStatus[value],
    [requestClientData.birthDate]: (date) => moment(date).format('DD.MM.YYYY'),
    [calculationCreditHistory.calculationDate]: (date) => moment(date).format('DD.MM.YYYY'),
    [requestClientData.phone]: (phoneNumber) => formatPhoneNumber(phoneNumber),
    [requestClientData.avgMonthlyIncome]: "BYN",
    [calculationCreditHistory.creditAmountSum]: "BYN",
    [calculationCreditHistory.creditOverdueSum]: "BYN",
    [calculationCreditHistory.totalSuretySum]: "BYN",
    [calculationCreditHistory.totalPaymentSum]: "BYN",
    [requestCreditHistory.time]: (date) => moment(date).format('DD.MM.YYYY, HH:mm'),
    [requestClientData.jobType]: (value) => JobType[value],
    [requestClientData.lastJobDuration]: (value) => JobTenure[value],
    [requestClientData.education]: (value) => Education[value],
    [requestClientData.familyStatus]: (value) => FamilyStatus[value],
    [requestClientData.accommodationType]: (value) => AccommodationType[value],
    [requestClientData.numberOfChildren]: (value) => value === 0 ? 'Нет' : value,
    [requestClientData.noCreditHistory]: (value) => Boolean(value) ? 'Нет' : 'Да',
    [requestClientData.accessDeniedByClient]: (value) => Boolean(value) ? 'Да' : 'Нет',
    [requestClientData.incomeVerificationDocument]: (value) =>
      <HCheckbox
        name='incomeConfirmed'
        className="input"
        checked={value}
        onChange={handleCheckboxChange}
      />,
  };

  if (value == null) return "";

  const formatter = unitMap[label];
  if (!formatter) return value;

  if (typeof formatter === "function") {
    return formatter(value);
  }

  return `${Intl.NumberFormat("ru-RU").format(value)} ${formatter}`;
};

export const formatPhoneNumber = (phone) => {
  const cleaned = phone?.replace(/\D/g, '');
  return `+${cleaned}`;
};
